module.exports = __webpack_public_path__ + "static/media/011.9fd3a291.jpg";